import { render, staticRenderFns } from "./goodsCustomTemplateDialog.vue?vue&type=template&id=47085dc8&scoped=true"
import script from "./goodsCustomTemplateDialog.vue?vue&type=script&lang=js"
export * from "./goodsCustomTemplateDialog.vue?vue&type=script&lang=js"
import style0 from "./goodsCustomTemplateDialog.vue?vue&type=style&index=0&id=47085dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47085dc8",
  null
  
)

export default component.exports